/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Address, AddressFromJSON, AddressToJSON } from './'

/**
 *
 * @export
 * @interface UpdateInvoiceSignatureRequestBody
 */
export interface UpdateInvoiceSignatureRequestBody {
  /**
   *
   * @type boolean
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  useDefaultSignature?: boolean
  /**
   *
   * @type string
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  payableTo: string
  /**
   *
   * @type string
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  phoneNumber?: string
  /**
   *
   * @type string
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  closingMessage?: string
  /**
   *
   * @type string
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  email?: string
  /**
   *
   * @type Address
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  address?: Address
  /**
   * Base64 encoded data that contains an image of a QR code which points to the user's payment information.
   * @type string
   * @memberof UpdateInvoiceSignatureRequestBody
   */
  qrCodeImage?: string
}

export function UpdateInvoiceSignatureRequestBodyFromJSON(
  json: any
): UpdateInvoiceSignatureRequestBody {
  return UpdateInvoiceSignatureRequestBodyFromJSONTyped(json, false)
}

export function UpdateInvoiceSignatureRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateInvoiceSignatureRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    useDefaultSignature: !exists(json, 'useDefaultSignature')
      ? undefined
      : json['useDefaultSignature'],
    payableTo: json['payableTo'],
    phoneNumber: !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
    closingMessage: !exists(json, 'closingMessage')
      ? undefined
      : json['closingMessage'],
    email: !exists(json, 'email') ? undefined : json['email'],
    address: !exists(json, 'address')
      ? undefined
      : AddressFromJSON(json['address']),
    qrCodeImage: !exists(json, 'qrCodeImage') ? undefined : json['qrCodeImage'],
  }
}

export function UpdateInvoiceSignatureRequestBodyToJSON(
  value?: UpdateInvoiceSignatureRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    useDefaultSignature: value.useDefaultSignature,
    payableTo: value.payableTo,
    phoneNumber: value.phoneNumber,
    closingMessage: value.closingMessage,
    email: value.email,
    address: AddressToJSON(value.address),
    qrCodeImage: value.qrCodeImage,
  }
}
